"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPropertyTransactionState = void 0;
var DetailState_init_1 = require("@/pages/detail/states/DetailState.init");
var ResultPageState_1 = require("@/pages/search/states/ResultPageState");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var DetailGalleryState_1 = require("@/pages/detail/states/DetailGalleryState");
var defaultTransactionProperty = {
    price: 35000000,
    salePrice: 35000000,
    leasePrice: 0,
    size: 1516,
    pricePerSqft: 23087,
    salePricePerSqft: 23087,
    salePricePerSqftGross: 0,
    salePricePerSqftSaleable: 23087,
    leasePricePerSqft: 0,
    leasePricePerSqftGross: 0,
    leasePricePerSqftSaleable: 0,
    description: '',
    images: [
        {
            path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
            caption: 'Property Photo',
        }
    ],
    amenities: [
        {
            key: 'bed',
            value: 3,
            displayKey: 'Bedrooms',
            displayValue: '3 BD',
        },
        {
            key: 'bath',
            value: 2,
            displayKey: 'Bathroom',
            displayValue: '2 BA',
        },
        {
            key: 'maid',
            value: 1,
            displayKey: "Maid's Room",
            displayValue: '1 MR',
        },
        {
            key: 'balcony',
            value: 1,
            displayKey: 'Balcony',
            displayValue: '1 BL',
        },
        {
            key: 'terrace',
            value: 1,
            displayKey: 'Terrace',
            displayValue: '1 TR',
        },
    ],
    isSoleAgent: false,
    isJointSoleAgent: false,
    includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
    building: 'Victoria Court',
    area: 'Discovery Bay',
    address: '50-56 Hing Fat Street',
    type: SfilterTypeGroup_1.SfilterType.BUY,
    sizeGross: 2100,
    sizeSaleable: 1516,
    isSaved: false,
    buildingAge: -1,
    floor: '',
    isSaving: false,
    isVirtual: false,
    isVideo: false,
    lastUpdated: new Date('2019-05-19T00:00:00'),
    referenceId: 9876543,
    lat: 22.2812449,
    lng: 114.1565716,
    propertyName: "3C, Blk 2, Victoria Court",
    sold: true,
};
var defaultPropertyTransasctionPhotos = [{
        type: DetailGalleryState_1.DetailGalleryItemType.IMAGE,
        thumb: 'https://images.okay.com/Property/HQ/olympian-mansion-mid-levels-west-for-sale-41830_637611772160997398.jpg',
        src: 'https://images.okay.com/Property/HQ/olympian-mansion-mid-levels-west-for-sale-41830_637611772160997398.jpg',
    }];
var defaultPropertyTransactionGallery = {
    id: 'detail',
    currentIndex: 2,
    items: defaultPropertyTransasctionPhotos,
    showMapView: true,
    showStreetView: true,
    showThumbs: true,
    showFloorPlan: true,
    showOverlay: true,
    isSoleAgent: false,
    t: {
        mapView: 'Map View',
        streetView: 'Street View',
        soleAgent: 'Sole Agent',
        video: 'Video',
        virtualTour: 'Virtual Tour',
    },
};
var defaultPropertyTransactionState = __assign(__assign({}, DetailState_init_1.defaultDetailState), { property: defaultTransactionProperty, gallery: __assign(__assign({}, defaultPropertyTransactionGallery), { showThumbs: false }), galleryPhotos: __assign(__assign({}, defaultPropertyTransactionGallery), { id: 'detailgallery', showMapView: false, showStreetView: false, showThumbs: false, showFloorPlan: false, showOverlay: false }), galleryFloorPlans: __assign(__assign({}, defaultPropertyTransactionGallery), { id: 'detailfloorplan', showMapView: false, showStreetView: false, showThumbs: false, showFloorPlan: false, showOverlay: false }), videos: [], mortgage: __assign(__assign({}, DetailState_init_1.defaultDetailState.mortgage), { price: defaultTransactionProperty.salePrice, downPayment: Math.ceil(defaultTransactionProperty.salePrice * 0.2) }) });
exports.defaultPropertyTransactionState = defaultPropertyTransactionState;
